import BaseModal from "@components/modals/BaseModal";
import SecondaryButton from "@components/ui/buttons/SecondaryButton";
import { METIER_META, metierLabel } from "../../types/garage/metier";

interface MetierMismatchModalProps {
  /** The compagnon's dispo zone métier at the drop slot */
  zoneMetier: string;
  /** The dragged magnet's métier */
  magnetMetier: string;
  onConfirm: () => void;
  onCancel: () => void;
}

function MetierChip({ metier }: { metier: string }) {
  const meta = METIER_META[metier];
  return (
    <span
      className="text-h4 font-medium px-2.5 py-0.5 rounded-full"
      style={{
        background: meta?.bg ?? "#F5F5F5",
        color: meta?.color ?? "#737373",
        border: `1px solid ${meta?.border ?? "#D9D9D9"}`,
      }}
    >
      {metierLabel(metier)}
    </span>
  );
}

export default function MetierMismatchModal({
  zoneMetier,
  magnetMetier,
  onConfirm,
  onCancel,
}: MetierMismatchModalProps) {
  return (
    <BaseModal title="Métier différent" onClose={onCancel} width="max-w-lg">
      <div className="flex flex-col gap-4 p-4">
        <div className="text-h3" style={{ fontFamily: "Poppins", color: "#525252" }}>
          Ce compagnon est disponible pour le métier <MetierChip metier={zoneMetier} /> mais
          cette charge est <MetierChip metier={magnetMetier} />.
        </div>
        <div className="text-h4" style={{ fontFamily: "Poppins", color: "#A1A1A1" }}>
          Voulez-vous quand même placer ce chantier sur ce compagnon ?
        </div>
      </div>

      <div className="border-t p-4 flex flex-row justify-end gap-2">
        <SecondaryButton variant="small" onClick={onCancel}>
          Annuler
        </SecondaryButton>
        <SecondaryButton variant="small" onClick={onConfirm}>
          Forcer le placement
        </SecondaryButton>
      </div>
    </BaseModal>
  );
}
